import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "my-4 mx-4" }
const _hoisted_2 = { class: "fs-6 d-inline-block me-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.t('periodo')), 1),
    _createVNode(_component_el_select, {
      modelValue: _ctx.gblPeriodo,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.gblPeriodo) = $event)),
      placeholder: "...",
      class: "w-100px"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listPeriods, (item, index) => {
          return (_openBlock(), _createBlock(_component_el_option, {
            key: 'prd-'+index,
            label: item.idanio,
            value: item.idanio
          }, null, 8, ["label", "value"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}